//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AutoOrder from "@/pages/UserSettings/BusinessSettings/AutoOrder/AutoOrder.vue";
// import OSA from "@/pages/UserSettings/BusinessSettings/OSA/OSA.vue";
import AutomaticPrices from "@/pages/UserSettings/BusinessSettings/AutomaticPrices/AutomaticPrices";
import PhantomStock from "@/pages/UserSettings/BusinessSettings/PhantomStock/PhantomStock.vue";
import BackendServices from "@/services/backend-services";

const EMPTY_SETTINGS = {
  business_tab: [],
};

export default {
  name: "UserSettings",
  components: {
    AutoOrder,
    PhantomStock,
    AutomaticPrices,
  },
  mounted: function () { },
  data: () => ({
    tab: "business",
    data: EMPTY_SETTINGS,
    selectedOption: {
      value: "phantom_stock",
      label: "Stock Fantasma",
    },
    businessOptions: [
      {
        value: "auto_order",
        label: "Encomenda automática",
      },
      {
        value: "osa",
        label: "OSA",
      },
      {
        value: "auto_pricing",
        label: "Preços Automáticos",
      },
      {
        value: "phantom_stock",
        label: "Stock Fantasma",
      },
    ],
  }),
  methods: {
    setConfig: function (event) {
      this.data.business_tab = event.data;
    },
    saveSettings: function () {
      BackendServices.saveConfig("auto_order", this.data.business_tab).then(
        () => window.location.reload()
      );
    },
  },
};
